import React from 'react';
import './AboutPage.css';

function AboutPage() {
  return (
    <div className="about-container">
      <h1>About Selenne Strategies</h1>
      <p>
        Selenne Strategies is dedicated to helping entrepreneurs and businesses achieve clarity, structure, and sustained growth. Our approach is rooted in practical, real-world experience combined with a deep understanding of the unique challenges faced by small and medium enterprises.
      </p>

      <h2>Our Philosophy</h2>
      <p>
        We believe that every business has the potential to thrive with the right guidance and tools. Our mission is to meet clients where they are in their journey — from idea stage to operational maturity — and provide strategic insight that empowers confident decisions.
      </p>

      <h2>Our Team</h2>
      <p>
        Our team consists of experienced professionals who bring diverse skills in business strategy, operations, finance, and technology. We are passionate about delivering tailored solutions that align with each client’s vision and goals.
      </p>

      <h2>Our Founder</h2>
      <p>
        Selenne Strategies was founded by Antonio Washington, a seasoned entrepreneur with extensive experience in launching and growing successful ventures. His hands-on approach and commitment to client success form the foundation of our work.
      </p>

      <h2>Our Approach</h2>
      <p>
        We provide actionable strategies, clear roadmaps, and ongoing support to help businesses build with confidence. Whether it’s structuring a new enterprise or optimizing existing operations, Selenne Strategies is your partner in growth.
      </p>
    </div>
  );
}

export default AboutPage;
